import React, { useEffect, useState } from "react";
import { useSupplier } from "./store";
import { Col, Row } from "react-bootstrap";
import CreateSupplier from "./CreateSupplier";
import CardDiv from "modules/common/card-div/CardDiv";

function WarehouseSupplier() {
  const { suppliersData, fetchSuppliers } = useSupplier();
  const [suppliers, setSuppliers] = useState([]);
  useEffect(() => {
      fetchSuppliers();
  }, []);

  useEffect(() => {
      setSuppliers(suppliersData);
  }, [suppliersData]);

  return (
    <div className="">
      <CardDiv
        title={
          <div className="d-flex justify-content-between">
            <div className="fs-2">Warehouse Supplier </div>
            <div>
              <CreateSupplier />{" "}
            </div>
          </div>
        }
        component={
          <div className="shadow p-0">
            <Row className="table-head rounded-top table-head">
              <Col md={2} className="fw-bold border border border-collapse p-3">
                Channel
              </Col>
              <Col md={2} className="fw-bold border border border-collapse p-3">
                Code
              </Col>
              <Col md={2} className="fw-bold border border border-collapse p-3">
                Supplier Phone Number
              </Col>
              <Col md={2} className="fw-bold border border border-collapse p-3">
                Supplier GST Number
              </Col>
              <Col md={2} className="fw-bold border border border-collapse p-3">
                Supplier Id In Accounting
              </Col>
              <Col md={2} className="fw-bold border border border-collapse p-3">
                Supplier Name
              </Col>
            </Row>
            {suppliers.length &&
              suppliers.map((supplier, index) => {
                return (
                  <Row
                    className={`table-row border-0 ${
                      index === suppliersData.length - 1 && `rounded-bottom`
                    }`}
                  >
                    <Col className="border border-collapse p-3" md={2}>
                      {supplier.channel}
                    </Col>
                    <Col className="border border-collapse p-3" md={2}>
                      {supplier.code}
                    </Col>
                    <Col className="border border-collapse p-3" md={2}>
                      {supplier.supplier_phone_number}
                    </Col>
                    <Col className="border border-collapse p-3" md={2}>
                      {supplier.supplier_gst_number}
                    </Col>
                    <Col className="border border-collapse p-3" md={2}>
                      {supplier.supplier_id_in_acounting}
                    </Col>
                    <Col className="border border-collapse p-3" md={2}>
                      {supplier.supplier_name}
                    </Col>
                  </Row>
                );
              })}
          </div>
        }
      />
    </div>
  );
}

export default WarehouseSupplier;
